import React from "react";
import { StatisticsComponentItemProps } from "./StatisticsComponentItemProps";
import { statisticsComponentItemStyles } from "./StatisticsComponentItemStyles";

export default function StatisticsComponentItem(
    props: StatisticsComponentItemProps
) {
    const classes = statisticsComponentItemStyles();
    return (
        <div className={classes.item}>
            <div className={classes.subTitle}>{props.subTitle}</div>
            <div className={classes.data}>
                {props.data}
                {props.data !== "No Data" && props.unit}
            </div>
        </div>
    );
}
